import { RouteLink } from '@mr-yum/frontend-core/dist/services/routes'
import { Button } from '@mr-yum/frontend-ui'
import { CartLayoutFooter } from 'components/Cart/shared'
import { isEonxEnvironment } from 'components/EonX/utils'
import { useLogger } from 'hooks/useLogger'
import { OrderingTypeSlug, routes } from 'lib/routes'
import React, { createElement, useCallback, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

const getOrderMoreButtonContent = (tabId?: string, orderId?: string) => {
  if (tabId && orderId) {
    return <FormattedMessage defaultMessage="Order more" id="CWI40c" />
  }

  if (tabId) {
    return <FormattedMessage defaultMessage="Order now" id="WBBaGW" />
  }

  return <FormattedMessage defaultMessage="Back to menu" id="AgoOEq" />
}

interface Props {
  venueSlug: string
  orderingTypeSlug?: OrderingTypeSlug
  orderId?: string
  tabId?: string
}

export const ConfirmationFooter = ({
  venueSlug,
  tabId,
  orderId,
  orderingTypeSlug,
}: Props) => {
  const loggerProps = useMemo(
    () => ({ defaultProperties: { orderId, tabId } }),
    [orderId, tabId],
  )
  const { logEvent } = useLogger(loggerProps)
  const onBackHome = useCallback(() => {
    logEvent('Clicked on back home CTA on order confirmation')
  }, [logEvent])
  const onManageMyTab = useCallback(() => {
    logEvent('Clicked on manage my tab CTA on tab confirmation')
  }, [logEvent])

  return (
    <>
      <div className="flex-1" />

      <CartLayoutFooter sticky noSpacer>
        <>
          {tabId && (
            <div className="mb-2">
              <RouteLink
                route={routes.socialTabManage}
                pathData={{ venueSlug, tabId }}
              >
                <Button
                  variant="primary-alternative"
                  as="a"
                  size="lg"
                  aria-label="Manage my group order"
                  onClick={onManageMyTab}
                  fullWidth
                >
                  <FormattedMessage
                    defaultMessage="Manage my group order"
                    id="w5/OUl"
                  />
                </Button>
              </RouteLink>
            </div>
          )}

          {!isEonxEnvironment() &&
            // eslint-disable-next-line react/no-children-prop
            createElement(RouteLink, {
              route: orderingTypeSlug ? routes.menuCategories : routes.venue,
              pathData: orderingTypeSlug
                ? { venueSlug, orderingTypeSlug }
                : { venueSlug },
              children: (
                <Button
                  as="a"
                  size="lg"
                  aria-label="Back home"
                  onClick={onBackHome}
                  fullWidth
                >
                  {getOrderMoreButtonContent(tabId, orderId)}
                </Button>
              ),
            })}
        </>
      </CartLayoutFooter>
    </>
  )
}
